import { Box, Button, Drawer, IconButton } from "@mui/joy";
import Logo from "../components/header/HeaderLogo";
import API_SERVICE from "../utils/apiService";
import { useEffect, useState } from "react";
import { setMapCenter, setMapZoom } from "../store";
import { useDispatch } from "react-redux";
import SearchBox from "../components/common/SearchBox";
import { useMediaQuery } from "@mui/material";
import ProfileAvatar from "../components/profile/ProfileAvatar";
import { CURRENT_LOCATION } from "../utils/constants";
import FilterOptions from "../components/place/filter/FilterOptions";
import TuneIcon from "@mui/icons-material/TuneRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { checkAuth } from "../utils/authService";

function HeaderLayout() {
  // search
  const dispatch = useDispatch();
  const [chosenPlaceId, setChosenPlaceId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyAuth = async () => {
      const authStatus = await checkAuth();
      setIsAuthenticated(authStatus);
    };
    verifyAuth();
  }, []);

  useEffect(() => {
    if (chosenPlaceId === null) {
      setChosenPlaceId(null);
      return;
    }
    const moveMap = async () => {
      const dataResponse =
        await API_SERVICE.fetchSelectedSuggestion(chosenPlaceId);
      dispatch(
        setMapCenter({
          lat: dataResponse["locationLat"],
          lng: dataResponse["locationLng"],
        }),
      );
      dispatch(setMapZoom(12));
    };
    moveMap();
  }, [chosenPlaceId, dispatch]);

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:900px)");

  const getGeoLocation = () => {
    if (!navigator.geolocation) {
      console.log("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        dispatch(
          setMapCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }),
        );
      },
      (error) => {
        console.log(error.message);
      },
    );
  };

  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = (inOpen) => (_event) => {
    setDrawerOpen(inOpen);
  };

  // Define a common style for navigation buttons
  const navButtonStyle = {
    border: "none",
  };

  // Handle forum navigation based on authentication status
  const handleForumClick = () => {
    if (isAuthenticated) {
      window.open("https://forum.corkatlas.com/session/sso", "_blank");
    } else {
      window.open("https://forum.corkatlas.com", "_blank");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
        paddingRight: "20px",
        paddingLeft: isMobile ? "15px" : "30px",
      }}
    >
      <Logo />
      {location.pathname.includes("/corkage") && (
        <SearchBox
          handleSelectOption={(placeId) => {
            if (placeId === CURRENT_LOCATION) {
              getGeoLocation();
              setChosenPlaceId(null);
              return;
            }
            setChosenPlaceId(placeId);
          }}
          placeholder="restaurant name, city"
          includeFilter
          currentLocation
          endDecorator={
            isTablet && (
              <IconButton onClick={toggleDrawer(true)}>
                <TuneIcon />
              </IconButton>
            )
          }
        />
      )}
      <Box
        sx={{
          display: "flex",
          gap: 2,
        }}
      >
        <Button
          variant={location.pathname.includes("/corkage") ? "solid" : "outlined"}
          color="neutral"
          onClick={() => navigate("/corkage")}
          sx={navButtonStyle}
        >
          Corkage
        </Button>
        <Button
          variant={location.pathname.includes("/news") ? "solid" : "outlined"}
          color="neutral"
          onClick={() => {
            alert("coming soon");
            // uncomment for local development
            // navigate("/news");
          }}
          sx={navButtonStyle}
        >
          News
        </Button>
        <Button
          variant={location.pathname.includes("/tasting-notes") ? "solid" : "outlined"}
          color="neutral"
          onClick={() => {
            alert("coming soon");
            // uncomment for local development
            // navigate("/tasting-notes");
          }}
          sx={navButtonStyle}
        >
          Tasting Notes
        </Button>
        <Button
          variant="outlined"
          color="neutral"
          onClick={handleForumClick}
          sx={navButtonStyle}
        >
          Forum
        </Button>
        <ProfileAvatar />
      </Box>
      {isTablet && location.pathname.includes("/corkage") && (
        <Drawer open={drawerOpen} onClose={toggleDrawer(false)}>
          <FilterOptions />
        </Drawer>
      )}
    </Box>
  );
}

export default HeaderLayout;
